import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../controllers/api";
import { loginAPI } from "../api/login";
import { tokenManager } from "services/client/token-manager";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(loginAPI, formData);
      if (response?.results?.token !== "") {
        const t = response?.results?.token;
        // TOKEN_PERSIST_DUMMY: Redux loginUser — access + auth (tokenManager, JWT expiry)
        tokenManager.setAccess(t);
      }
      return response.results;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    status: false,
    userData: null,
    error: null,
    loading: false,
    isLoggedIn: false,
    isLoggedOut: false,
  },
  reducers: {
    logout: (state) => {
      state.status = false;
      state.userData = null;
      state.error = null;
      state.loading = false;
      state.isLoggedOut = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = true;
        state.userData = action.payload;
        state.loading = false;
        state.isLoggedIn = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
